module.exports = __webpack_public_path__ + "static/media/facebook.0575b028.svg";